<ifr-page-title pageTitle="'LEFT_PANEL_MY_DATA' | translate "/>

<my-data-container
  profile-image="vm.profileImage"
  profile-image-format="vm.profileImageFormat"
/>
